import { useAreFeatureFlagsLoading } from '@launcher/context/FeatureFlags.context';
import { getAuthenticationError, getIsUserLoading } from '@store/user/user.selector';
import { useSelector } from 'react-redux';

// An authentication error ends the loading state, whatever is still pending.
export const useIsAppLoading = (): boolean => {
  const isUserLoading = useSelector(getIsUserLoading);
  const areFeatureFlagsLoading = useAreFeatureFlagsLoading();
  const authenticationError = useSelector(getAuthenticationError);

  return (isUserLoading || areFeatureFlagsLoading) && !authenticationError;
};
